import { render, staticRenderFns } from "./FlexiblePaymentConditionPill.vue?vue&type=template&id=d0256488"
import script from "./FlexiblePaymentConditionPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlexiblePaymentConditionPill.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports